import { render, staticRenderFns } from "./Statement.vue?vue&type=template&id=9db17d8c&scoped=true&"
import script from "./Statement.vue?vue&type=script&lang=js&"
export * from "./Statement.vue?vue&type=script&lang=js&"
import style0 from "./Statement.vue?vue&type=style&index=0&id=9db17d8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db17d8c",
  null
  
)

export default component.exports